'use client'

import { createContext, ReactNode, useState } from "react"

export const PageTitleContext = createContext<{ 
    pageTitle: string
    SetPageTitle: (title: string)=> void
}>({
    pageTitle: "",
    SetPageTitle: ()=> {}
})

export default function PageTitleProvider({children}: {children: ReactNode}){
    const [pageTitle, setPageTitle] = useState<string>("")

    const SetPageTitle = (title: string)=> {
        setPageTitle(title)
    }

    return (
        <PageTitleContext.Provider value={{ pageTitle, SetPageTitle }}>
            {children}
        </PageTitleContext.Provider>
    )
}